import React, { useEffect, useState, useMemo } from "react"
import { motion } from 'framer-motion'
import API from "../../Common/API"
import DatatableLoader from "../../Components/Loaders/DataTableLoader"
import { datatableTheme } from "../../Common/dataTableTheme"
import DataTable, { createTheme } from "react-data-table-component"
import InlineTextField from "../../Components/InLineTextField"
import { useHistory } from "react-router-dom"
import {  FaPen } from "react-icons/fa6"
import { useDispatch } from "react-redux"
import * as Yup from 'yup'
import { useFormik } from "formik"
import { setAlert } from "../../Store/Theme/actions"
import FieldInput from "../../Components/FieldInput"
import Dialog from "../../Components/Dialog"
import FieldSelect from '../../Components/FieldSelect'
import Button from "../../Components/Button"

createTheme('defaultLight', datatableTheme.default)
createTheme('defaultDark', datatableTheme.dark)

const planDate = {
    planValidityDate : ''
}

const PlanValidity = () => {

    const [planList, setPlanList] = useState([])
    const [loading, setLoading] = useState(true)
    const [filter, setFilter] = useState('')
    const dispatch = useDispatch()
    const [count, setCount] = useState(0)
    const [planEditDialog,setPlanEditDialog] = useState(false)
    const [formData,setFormData] = useState(planDate)
    const [currentPlan,setCurrentPlan] = useState()
    const [planMenu,setPlanMenu] = useState([])
    const [openchangeStatus,setOpenChangeStatus] = useState(false)

    useEffect(() => {
        setLoading(true)
        try {
            API.get('/plans/getAllUserPlan').then((planRes) => {
                if (planRes.status === 200) {
                    setPlanList(planRes.data.data)
                    setLoading(false)
                }
            })
             API.get('/plans/getPlansList').then((planRes) => {
            if (planRes.status === 200) {
                setPlanMenu(planRes.data.data.map((c) => { return { text: c.planName, value: c._id, validity:c.planValidity } }))
            }
        })
        } catch (err) {
            console.log(err)
        }
    }, [count])

    const columns = useMemo(() => [
        { name: 'S.No', selector: (row, i) => i + 1, initialActive: true, sortable: true, width: '100px' },
        {name : 'RefId',selector:row=>row.userId.refId,initialActive:true,sortable:true},
        { name: 'User Name', selector: row => row.userId.firstName + " " + row.userId.lastName, initialActive: true, sortable: true },
        { name: 'Plan Name', selector: row => row.planId.planName, initialActive: true, sortable: true },
        { name: 'Plan Rate', selector: row => row.planId.planRate, sortable: true },
        { name: 'Plan Validity', selector: row => <motion.div className="flex flex-row w-full">{row.planValidityDate.split('-')[2] + '/' + row.planValidityDate.split('-')[1] + '/' + row.planValidityDate.split('-')[0]}</motion.div>, sortable: true },
        {
            name: 'Action', selector: row => <motion.div className="relative flex flex-row w-full justify-between">
                {/* {row.activeStat === 'D' && <FaCircleCheck color="green" className="mx-2 cursor-pointer" onClick={() => activatePlans(row)} />}
                {row.activeStat === 'A' && <RiCloseCircleFill color="red" className="mx-2 cursor-pointer" onClick={() => deactivatePlans(row)} />} */}
                {<motion.div className="mx-2 text-[indigo] cursor-pointer" onClick={() => editPlans(row)}>
                    <FaPen title="Plan Edit" />
                </motion.div>}
            </motion.div>, initialActive: true, sortable: true
        },
        {
            name: 'Renew', selector: row => <motion.div className="relative flex flex-row w-full justify-between">
                {/* {row.activeStat === 'D' && <FaCircleCheck color="green" className="mx-2 cursor-pointer" onClick={() => activatePlans(row)} />}
                {row.activeStat === 'A' && <RiCloseCircleFill color="red" className="mx-2 cursor-pointer" onClick={() => deactivatePlans(row)} />} */}
                {new Date(row.planValidityDate) < new Date()  && <motion.div className="mx-2 text-[indigo] cursor-pointer" onClick={() => openStatuses(row)}>
                    Renew
                </motion.div>}
            </motion.div>, initialActive: true, sortable: true
        }
    ], [])

    const openStatuses = (row) => {
        setOpenChangeStatus(true)
        planForm.setValues({ ...planForm.values, userId: row.userId._id,planId:row.planId._id })
    }

    const flattenObjectValues = (obj) => {
        let result = [];
    
        const recurse = (value) => {
            if (value === null || value === undefined) return;
            if (typeof value === 'object') {
                for (const key in value) {
                    recurse(value[key]);
                }
            } else {
                result.push(value.toString().toLowerCase());
            }
        };
    
        recurse(obj);
        return result.join(' ');
    };

    const filteredcasedetails = useMemo(() => {
    const filterSplit = filter.toLowerCase().split(' ');
    return planList.filter(c => {
        const flatString = flattenObjectValues(c);
        return filterSplit.every(term => flatString.includes(term));
    });
}, [planList, filter]);

    const SubHeader = useMemo(() => (
        <div className="flex flex-row items-center">
            <InlineTextField label={"Search"} value={filter} setValue={setFilter} />
            {/* <motion.div className="h-9 mx-2 w-9 rounded-full bg-white flex flex-col items-center cursor-pointer justify-center" onClick={() => history.push(`/createPlan`)}><FaPlus /></motion.div> */}
        </div>
    ), [filter])// eslint-disable-line

    const editPlans = (value) => {
        setCurrentPlan(value)
        const parsedDate = value.planValidityDate ? new Date(value.planValidityDate) : new Date()
        setFormData({ ...formData, ...value, planValidityDate: parsedDate })
        setPlanEditDialog(true)
    }

    const planValiditySchema = Yup.object().shape({
        planId:Yup.string().required("Plan is required"),
        planValidityDate : Yup.string().required("Plan Validity Date is required")
    })

    const planForm = useFormik({
        initialValues : formData,
        enableReinitialize : true,
        validateOnMount : true,
        validationSchema : planValiditySchema,
        onSubmit : (values)=>{
            let val = {
                userId : values.userId._id,
                planId: values.planId,
                planValidityDate : new Date(values.planValidityDate).toISOString().split('T')[0]
            }
            API.post('/plans/editSubscription',val).then((planRes)=>{
                if(planRes.status === 200){
                    dispatch(setAlert({title:'Success',subtitle:'Plan Edited Successfully',active:true,type:'success'}))
                    planForm.resetForm()
                    setPlanEditDialog(false)
                    setCount(count+1)
                }
            }).catch((err)=>{
                console.log(err)
                dispatch(setAlert({title:'Error',subtitle:'Something went wrong',active:true,type:'error'}))
            })
        }
    })

    const changeValidatiyDate = (value)=>{
        const updatedPlan = planMenu.find((plan)=>plan.value === value)
        const planValidityDate = new Date(currentPlan.createdAt)
        planValidityDate.setDate(planValidityDate.getDate() + parseInt(updatedPlan.validity))
        planForm.setFieldValue('planValidityDate',planValidityDate.toISOString().split('T')[0])
        console.log(updatedPlan,currentPlan.createdAt,planValidityDate)
    }

    const activatePlan = () => {
        let apiValues = {
            planId: planForm.values.planId,
            userId: planForm.values.userId,
            planValidityDate: new Date(Date.now() + planMenu.filter((x) => x.value === planForm.values.planId)[0].validity * 24 * 60 * 60 * 1000).toISOString(),
            downloadCount: 0,
        }
        API.post('/plans/subscribe', apiValues).then((subRes) => {
            if (subRes.status === 200) {
                dispatch(setAlert({ title: "Success", subtitle: 'Plan Activated Successfully', active: true, type: 'success' }))
                setCount(count + 1)
                setOpenChangeStatus(false)
            }
        }).catch((err) => {
            dispatch(setAlert({ title: "Error", subtitle: 'Something went wrong', active: true, type: 'error' }))
        })
    }

    return (
        <motion.div>
            {loading ? (
                <DatatableLoader />
            ) : (
                <motion.div className="h-full w-full bg-opacity-10 drop-shadow-lg">
                    <DataTable
                        title="Plan List"
                        theme="defaultLight"
                        columns={columns}
                        data={filteredcasedetails}
                        pagination
                        highlightOnHover
                        selectableRowsHighlight
                        persistTableHead
                        subHeader
                        subHeaderComponent={SubHeader}
                        noDataComponent={'There are no records to display'}
                    />
                </motion.div>
            )}
            <Dialog injectClass={'w-[450px] h-fit'} showDialog={planEditDialog} title={'Edit Plan Validity'} onClose={() => setPlanEditDialog(false)}>
                <motion.div className="flex w-full gap-5 my-2 flex-col">
                <motion.div className="grid grid-cols-1 gap-5 my-2 w-full">
                    <p>Current Plan : {currentPlan?.planId?.planName}</p>
                    <FieldSelect label={'Edit Plan'} outerInjectClass={'w-full'} fieldHelper={planForm.getFieldHelpers('planId')} fieldMeta={planForm.getFieldMeta('planId')} fieldProps={planForm.getFieldProps('planId')} edit={true} dataLoaded={true} options={planMenu} onChange={(ev)=>changeValidatiyDate(ev)}/>
                    <FieldInput label={'Plan Validity Date'} outerInjectClass={'w-full'} type="date" fieldHelper={planForm.getFieldHelpers('planValidityDate')} fieldMeta={planForm.getFieldMeta('planValidityDate')} fieldProps={planForm.getFieldProps('planValidityDate')} edit={true} dataLoaded={true}/>
                </motion.div>
                    <motion.div className="flex flex-row justify-between">
                        <motion.div className="bg-[grey] text-black cursor-pointer px-2 py-1" onClick={()=>setPlanEditDialog(false)}>
                            Cancel
                        </motion.div>
                        <motion.div className="bg-primeColor text-white cursor-pointer px-2 py-1" onClick={()=>planForm.submitForm()}>
                            Save
                        </motion.div>
                    </motion.div>
                </motion.div>
            </Dialog>

            <Dialog injectClass="w-350px" showDialog={openchangeStatus} title={'Activate Plan'} onClose={() => setOpenChangeStatus(false)}>
                <motion.div className="w-full flex flex-col">
                    <FieldSelect label={'Choose Plan'} fieldProps={planForm.getFieldProps('planId')} fieldHelper={planForm.getFieldHelpers('planId')} fieldMeta={planForm.getFieldMeta('planId')} edit={true} dataLoaded={true} options={planMenu} />
                    <motion.div className="w-full flex flex-row justify-between">
                        <Button injectClass={'text-black rounded-full cursor-pointer'} onClick={() => setOpenChangeStatus(false)}>Cancel</Button>
                        <Button injectClass={'bg-primeColor text-white rounded-full cursor-pointer'} onClick={() => activatePlan()}>Activate</Button>
                    </motion.div>
                </motion.div>
            </Dialog>
        </motion.div>
    )
}

export default PlanValidity